// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --buttonColor: #00A19B;
  --buttonHover: #00A19B;
  --kycBackground: linear-gradient(97deg, #fbc425b0, #b18a1a7c, #7e621357);
  --buttonBorder: linear-gradient(270deg, #4d3901, #fcce2c);
  --textLightColor: rgb(134, 134, 134);

  --backgroundGradient: linear-gradient(to left, #5d3792, #ff4b93);
}
`, "",{"version":3,"sources":["webpack://./src/utils/Colors.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;EACxE,yDAAyD;EACzD,oCAAoC;;EAEpC,gEAAgE;AAClE","sourcesContent":[":root {\n  --buttonColor: #00A19B;\n  --buttonHover: #00A19B;\n  --kycBackground: linear-gradient(97deg, #fbc425b0, #b18a1a7c, #7e621357);\n  --buttonBorder: linear-gradient(270deg, #4d3901, #fcce2c);\n  --textLightColor: rgb(134, 134, 134);\n\n  --backgroundGradient: linear-gradient(to left, #5d3792, #ff4b93);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
